// extracted by mini-css-extract-plugin
export default {"getOutline":"Modal_getOutline__zzCRf","TextDialogButtons":"Modal_TextDialogButtons__1xyL4","TextDialogPrimary":"Modal_TextDialogPrimary__QSc3D"};